import axios from "axios";
// import BaseHelper from "./baseHelper";

class AdminHelper {
  async axiosReq(request) {
    try {
      const {
        data = {},
        url,
        headers,
        methodName = "unknown",
        method,
      } = request;

      const requestOptions = {
        method: method || "POST",
        url,
        data: request.data,
        headers,
      };

      //   window.kiviLogger.info(
      //     `requestOptions for ${methodName}:  ${JSON.stringify(requestOptions)}`
      //   );

      const response = await axios(requestOptions);
      return this.responseHandler(response);
    } catch (error) {
      return this.errorHandler(error);
    }
  }

  allowedPages(team, level = 0) {
    const validViews = {
      dev: {
        0: ["addUser", "vaccinePage", "seedAndFix", "reports", "verification"],
      },
      admin: {
        0: ["vaccinePage"],
      },
      partner: {
        0: ["partnerModule"],
      },
      vaccinationStatsAdmin: {
        0: ["vaccinationStatsAdmin"],
      },
      analytics: {
        0: ["reports", "vaccinationStatsAdmin"],
      },
      partnerGroup: {
        0: ["partnerGroup"],
      },
      corporateFinance: {
        0: ["corporateFinance"],
      },
      operations: {
        0: ["verification"],
      },
    };

    if (!team) return [];

    const defaultTeams = [
      "admin",
      "analytics",
      "dev",
      "partnerGroup",
      "vaccinationStatsAdmin",
      "corporateFinance",
      "operations",
    ];
    if (defaultTeams.includes(team)) {
      return validViews[team][level];
    }

    /* team is corporate id, will update this logic later */
    team = "partner";

    if (level > 0) {
      return ["partnerModule"];
    }

    return validViews[team][level];
  }

  isAuthorizedUser(viewName, team, level) {
    const allowedPages = this.allowedPages(team, level);
    const isAuthorized = allowedPages.includes(viewName);
    return isAuthorized;
  }

  validData = (data) => {
    const noData = typeof data === "undefined";
    if (noData) return "No data";
    return data;
  };
}

export default new AdminHelper();
